module.exports = __webpack_public_path__ + "img/card-bg-3.d026f4f.png";